import { connect } from 'react-redux';
import { IAppState } from '../../../models/reduxState';
import { isGetHelpSelector } from '../../app/selectors/contactUsSelector';
import { SignInScenario } from '../presentationalComponents/SignInScenario';
import { dispatchSignInUserIntoClientApp } from '../reduxUpdater/dispatchers/contactUsDispatchers';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
    return {
        userIsSigningIntoClientApp: state.ContactState.ModalitySectionState.isUserIsSigningIntoClientApp,
        showModalitiesStickyFooter: state.ContactState.SelfHelpAlchemyState.showModalitiesStickyFooter,
        isGetHelp: isGetHelpSelector(state),
    };
};

const mapDispatchToProps = {
    dispatchSignInUserIntoClientApp,
};

export const SignInScenarioContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SignInScenario);
